import moment from 'moment';

import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'checkConversationDate', standalone: true })
export class CheckDifferentConversationDatePipe implements PipeTransform {
  transform(message: any, prevMessage: any): boolean {
    const firstDate = moment.utc(message.eventTime).format('L');
    const secondDate = moment.utc(prevMessage.eventTime).format('L');
    return firstDate !== secondDate;
  }
}

@Pipe({ name: 'checkConversationMember', standalone: true })
export class CheckDifferentConversationMemberPipe implements PipeTransform {
  transform(current: any, last: any): boolean {
    return checkDifferentMember(current, last);
  }
}

@Pipe({ name: 'messageHiddenTime', standalone: true })
export class MessageHiddenTimePipe implements PipeTransform {
  transform(message: any, prevMessage: any): boolean {
    if (!prevMessage) {
      return true;
    } else {
      return (
        checkMessageFrequency(message, prevMessage) &&
        !checkDifferentMember(message, prevMessage)
      );
    }
  }
}

const checkMessageFrequency = (message: any, prevMessage: any) => {
  const timeDiff =
    new Date(message.eventTime).getTime() -
    new Date(prevMessage.eventTime).getTime();
  return timeDiff < 600000; // 10 min
};

const checkDifferentMember = (current: any, last: any) => {
  return current?.message?.from !== last?.message?.from;
};
